// Whether the mic button can work at all in this browser (ENG-014: shared by the mic button in
// QuestionInput and the auto-send toggle in the profile menu). It only needs a secure context
// and some way to capture audio: the browser's own SpeechRecognition, or getUserMedia (for the
// Azure backend) — which is what makes the button appear inside the Genie/Android WebView.

export const supportsBrowserSpeechRecognition = (): boolean => typeof window !== "undefined" && !!(window.SpeechRecognition || window.webkitSpeechRecognition);

export const isSpeechInputSupported = (): boolean => {
    if (typeof window === "undefined" || window.isSecureContext === false) {
        return false;
    }
    const supportsGetUserMedia = !!window.navigator?.mediaDevices?.getUserMedia;
    return supportsBrowserSpeechRecognition() || supportsGetUserMedia;
};
